import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

const STATS = [
  { n: "15", label: "SITES ON THE MAP" },
  { n: "45", label: "HYPOTHESES FILED" },
  { n: "0", label: "CONCLUSIONS FORCED" },
];

export default function Manifesto() {
  return (
    <section
      id="premise"
      data-testid="premise-section"
      className="relative z-10 border-t border-[#D4AF37]/10 bg-[#0B0C10]/92 py-24 backdrop-blur-sm lg:py-32"
    >
      <div className="mx-auto grid max-w-[1680px] gap-14 px-5 lg:grid-cols-12 lg:px-16">
        <div className="lg:col-span-7">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7, ease: EASE }}
            className="mb-8 font-mono text-[10px] tracking-[0.4em] text-[#D4AF37]"
          >
            THE PREMISE — 01
          </motion.p>

          <motion.h2
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.9, delay: 0.1, ease: EASE }}
            className="font-serif text-4xl leading-[1.05] sm:text-5xl lg:text-6xl"
          >
            History is a draft,
            <br />
            <em className="italic text-[#D4AF37]">not a verdict.</em>
          </motion.h2>

          <motion.div
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.9, delay: 0.22, ease: EASE }}
            className="mt-9 max-w-[560px] space-y-5 text-sm font-light leading-relaxed text-white/60 sm:text-base"
          >
            <p>
              Some monuments refuse to sit still in the timeline. A sanctuary
              older than farming. Stones too heavy for their own emperors. A
              desert drawn for eyes in the sky.
            </p>
            <p>
              This atlas gathers the places where the narrative keeps changing
              — not to hand you a replacement story, but to show both columns
              side by side and let the question breathe. Spin the globe. Open a
              beacon. Read the mainstream, then read the margins.
            </p>
          </motion.div>

          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.9, delay: 0.35 }}
            className="mt-8 border-l border-[#D4AF37]/40 pl-4 font-mono text-[10px] leading-relaxed tracking-[0.14em] text-white/40"
          >
            PRESENTED WITH RESPECT: MAINSTREAM ARCHAEOLOGY IS SHOWN IN FULL.
            ALTERNATIVE READINGS ARE LABELLED AS CLAIMS. WONDER DOES THE REST.
          </motion.p>
        </div>

        <div className="flex flex-col justify-center gap-10 lg:col-span-4 lg:col-start-9">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, x: 40 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.8, delay: i * 0.14, ease: EASE }}
              className="border-b border-[#D4AF37]/15 pb-6"
              data-testid={`premise-stat-${i}`}
            >
              <div className="font-serif text-6xl font-light text-[#D4AF37] lg:text-7xl">
                {s.n}
              </div>
              <div className="mt-2 font-mono text-[10px] tracking-[0.35em] text-white/50">
                {s.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
